




















































































import Vue from "vue";
import Api from "../../base/api.typings";
import Component from "vue-class-component";
import relatorioService from "./relatorio-service";
import * as val from "../../base/validations";
import areaService from '../area-atual/area-service';

@Component
export default class RelatorioDocumentoListar extends Vue {
    areaAtual: string = null;

    aba: number = 0;

    empresas: Api.App.Server.Empresa.Listar.EmpresaDto[] = [];

    resumo: Api.App.Server.Relatorio.RelatorioUsuarioNovoListar.RelatorioDto[] = [];

    inicioOpcional: string = null;

    fimOpcional: string = null;

    get carregando() { return !this.resumo };

    cabecalho: any = [
        {
            text: 'Id',
            align: 'center',
            sortable: false,
            value: 'usuarioId'
        },
        { text: 'Nome', value: 'nome' },
        { text: 'E-mail', value: 'email' },
    ];

    async created() {
        this.areaAtual = await areaService.obterAreaPadrao();
        if (this.areaAtual == 'admin') {
            this.listar();
        }
    }

    beforeRouteUpdate() {
        this.listar();
    }

    periodos = [
        { value: Api.Common.Domain.RelatorioPeriodoEnum.SeteDias, text: 'Últimos 7 dias' },
        { value: Api.Common.Domain.RelatorioPeriodoEnum.Hoje, text: 'Hoje' },
        { value: Api.Common.Domain.RelatorioPeriodoEnum.TrintaDias, text: 'Últimos 30 dias' },
        { value: Api.Common.Domain.RelatorioPeriodoEnum.Personalizado, text: 'Personalizado' },
    ];

    situacaoUsuario = [
        { value: Api.Common.Domain.SituacaoRelatorioEnum.Ativo, text: 'Ativos' },
        { value: Api.Common.Domain.SituacaoRelatorioEnum.Tudo, text: 'Todos' },
    ];

    situacaoSelecionada: Api.Common.Domain.SituacaoRelatorioEnum.Ativo = Api.Common.Domain.SituacaoRelatorioEnum.Ativo;

    filtro: Api.Common.Domain.RelatorioPeriodoEnum = 2;
    get filtroData(): Api.Common.Domain.RelatorioPeriodoEnum { return this.filtro };

    private async listar() {
        let resultado;

        if ((this.filtroData == 4 && (this.inicioOpcional && this.fimOpcional)) || this.filtroData != 4) {
            resultado = await relatorioService.listarUsuarioNovo({
                periodo: this.filtroData,
                inicioOpcional: this.inicioOpcional,
                fimOpcional: this.fimOpcional,
                situacaoUsuario: this.situacaoSelecionada
            });
            this.resumo = resultado.usuarios;
        }
    }

    imprimirRelatorio() {
        window.print();
    }

    rules = {
        $summary: [] as any[],
        inicioOpcional: [val.required],
        fimOpcional: [val.required],
    };
}
